import React from 'react';
import watermarkImg from '../../assets/watermark.png';

/**
 * Home page component with watermark background
 */
const HomePage: React.FC = () => {
  return (
    <div className="homeContainer">
      <div className="watermarkContainer">
        <img src={watermarkImg} alt="" className="watermarkImage" />
        <div className="content">
        </div>
      </div>
    </div>
  );
};

export default HomePage;
